import React from "react";
import styles from "./NewUser.module.css";
import Loader from "../../../components/Loader";
import Alert from "../../../components/Alert";
import { useTranslation } from "react-i18next";
import Button from "../../../components/Button";
import { client } from "../../../utils/api-client";
import { useNavigate } from "react-router-dom";

const NewUser = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const navigate = useNavigate();

  const validatePresence = (fieldsObject) => {
    let missingFields = [];
    let valid = true;

    Object.keys(fieldsObject).forEach((field) => {
      if (fieldsObject[field] === "") {
        valid = false;
        missingFields.push(field);
      }
    });

    return valid ? valid : missingFields;
  };

  const markRequiredFields = (form, missingFields) => {
    missingFields.forEach((field) =>
      form.elements[field].classList.add(styles.required)
    );
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    setIsLoading(true);

    const {
      name,
      first_last_name,
      second_last_name,
      email,
      membership,
      day,
      month,
      year,
      ghin,
      hi,
    } = ev.target.elements;

    const requiredFieldsPresent = validatePresence({
      name: name.value,
      first_last_name: first_last_name.value,
      second_last_name: second_last_name.value,
      membership: membership.value,
      email: email.value,
    });

    if (requiredFieldsPresent === true) {
      client(`users.json`, {
        method: "POST",
        body: JSON.stringify({
          user: {
            first_name: name.value,
            first_last_name: first_last_name.value,
            second_last_name: second_last_name.value,
            email: email.value,
            membership: membership.value,
            birthday: `${year.value}-${month.value}-${day.value}`,
            ghin: ghin.value,
            hi: hi.value,
          },
        }),
      })
        .then((response) => {
          setIsLoading(false);
          navigate(`/admin/users/${response.user_id}`);
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
        });
    } else {
      setIsLoading(false);
      setError(t("register.missingFields"));
      markRequiredFields(ev.target, requiredFieldsPresent);
    }
  };

  return (
    <div className={styles.wrapper}>
      {error !== "" && <Alert>{error}</Alert>}
      <form onSubmit={handleSubmit}>
        <div>
          <label className={styles.requiredLabel}>{t("register.name")}</label>
          <input
            className={styles.input}
            id="name"
            type="text"
            name="name"
          ></input>
        </div>
        <div className={styles.inputGroup}>
          <div>
            <label className={styles.requiredLabel}>
              {t("register.firstLastName")}
            </label>
            <input
              className={styles.input}
              id="first_last_name"
              type="text"
              name="first_last_name"
            ></input>
          </div>
          <div>
            <label className={styles.requiredLabel}>
              {t("register.secondLastName")}
            </label>
            <input
              className={styles.input}
              id="second_last_name"
              type="text"
              name="second_last_name"
            ></input>
          </div>
        </div>
        <div className={styles.inputGroup}>
          <div>
            <label className={styles.requiredLabel}>
              {t("register.email")}
            </label>
            <input
              className={styles.input}
              id="email"
              type="text"
              name="email"
            ></input>
          </div>
        </div>
        <div>
          <label className={styles.requiredLabel}>
            {t("register.membership")}
          </label>
          <input
            className={styles.input}
            id="membership"
            type="text"
            name="membership"
          ></input>
        </div>
        <label className={styles.label}>{t("register.dateOfBirth")}</label>
        <div className={styles.birthdayField}>
          <input
            className={styles.input}
            id="day"
            type="text"
            name="day"
            placeholder="DD"
          ></input>
          <div className={styles.divider}>/</div>
          <input
            className={styles.input}
            id="month"
            type="text"
            name="month"
            placeholder="MM"
          ></input>
          <div className={styles.divider}>/</div>
          <input
            className={`${styles.input} ${styles.yearInput}`}
            id="year"
            type="text"
            name="year"
            placeholder={t("register.year")}
          ></input>
        </div>
        <div className={styles.inputGroup}>
          <div>
            <label className={styles.label}>{t("register.ghinId")}</label>
            <input
              className={styles.input}
              id="ghin"
              type="text"
              name="ghin"
            ></input>
          </div>
          <div>
            <label className={styles.label}>
              {t("register.handicapIndex")}
            </label>
            <input
              className={styles.input}
              id="hi"
              type="text"
              name="hi"
            ></input>
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <div className={styles.actionsWrapper}>
            <Button className={styles.submitButton} type="submit">
              {t("admin.users.addUser")}
            </Button>
          </div>
        )}
      </form>
    </div>
  );
};

export default NewUser;
